import { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import type { MouseEvent } from 'react';
import type { Announcement } from '@internal/plugin-management-common';

interface HomeCarouselControlsProps {
  announcements: Announcement[];
  index: number;
  onSelect: (index: number) => void;
}

export const HomeCarouselControls = ({
  announcements,
  index,
  onSelect,
}: HomeCarouselControlsProps) => {
  const classes = useStyles();
  const handleSelect = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      onSelect(Number(event.currentTarget.dataset.index));
    },
    [onSelect],
  );

  return (
    <div className={classes.progress}>
      {announcements.map((announcement, position) => (
        <div
          key={announcement.id || announcement.title}
          data-index={position}
          className={`${classes.segment} ${
            position === index ? classes.active : ''
          }`}
          onClick={handleSelect}
          aria-label={`Anuncio ${position + 1}`}
          aria-pressed={position === index}
        />
      ))}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  progress: {
    display: 'flex',
    gap: 2,
    backgroundColor: theme.palette.background.paper,
  },
  segment: {
    position: 'relative',
    flex: 1,
    height: 3,
    cursor: 'pointer',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      backgroundColor: theme.palette.action.disabledBackground,
    },
    '&:hover::before': { backgroundColor: theme.palette.text.disabled },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2,
    },
  },
  active: { '&::before': { backgroundColor: theme.palette.secondary.main } },
}));
